import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MotorReservaComponent } from './components/motor-reserva/motor-reserva.component';
import { CarouselModule, AccordionModule } from 'ngx-bootstrap';
import { PopoverModule } from 'ngx-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { BsDropdownModule } from 'ngx-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SeccionDescubreenjoyComponent } from './components/seccion-descubreenjoy/seccion-descubreenjoy.component';
import { PaginationModule } from 'ngx-bootstrap';
import { AlertModule } from 'ngx-bootstrap/alert';
import { MapsComponent } from './components/maps/maps.component';
import { MenuMobileComponent } from './components/menu-mobile/menu-mobile.component';
import { CotizacionComponent } from './components/cotizacion/cotizacion.component';
import { Ng2Rut } from 'ng2-rut';
import { Error404Component } from './components/error404/error404.component';
import { NumberDirective } from './directives/number.directive';
import { NumberLettersDirective } from './directives/number-letters.directive';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ModalSuccesEnjoyClComponent } from './components/modal-succes-enjoy-cl/modal-succes-enjoy-cl.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { CleanUrlPipe } from './pipes/clean-url.pipe';

import { SlickCarouselModule } from 'ngx-slick-carousel';
import { FormatTextPipe } from './pipes/format-text.pipe';
import { SafePipe } from './pipes/safe-img.pipe';
import { DomSanitizerPipe } from './pipes/dom-sanitizer.pipe';
import { ModalErrorEnjoyClComponent } from './components/modal-error-enjoy-cl/modal-error-enjoy-cl.component';
import { DataGuard } from './guard/data.guard';
import { UnidadGuard } from './guard/unidad.guard';
import { ServicioGuard } from './guard/servicio.guard';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        Ng2Rut,
        RouterModule,
        ReactiveFormsModule,
        NgxSpinnerModule,
        ModalModule.forRoot(),
        CarouselModule.forRoot(),
        BsDropdownModule.forRoot(),
        BsDatepickerModule.forRoot(),
        PaginationModule.forRoot(),
        AlertModule.forRoot(),
        AccordionModule.forRoot(),
        PopoverModule.forRoot(),
        TabsModule.forRoot(),
        SlickCarouselModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: (http: HttpClient) => {
                    return new TranslateHttpLoader(http);
                },
                deps: [HttpClient]
            }
        }),
    ],

    exports: [
        ReactiveFormsModule,
        RouterModule,
        CommonModule,
        CarouselModule,
        MotorReservaComponent,
        SeccionDescubreenjoyComponent,
        PaginationModule,
        AlertModule,
        AccordionModule,
        MapsComponent,
        CotizacionComponent,
        Ng2Rut,
        NumberDirective,
        NumberLettersDirective,
        BsDatepickerModule,
        TabsModule,
        ModalModule,
        NgxSpinnerModule,
        TranslateModule,
        FormsModule,
        SlickCarouselModule,
        FormatTextPipe,
        CleanUrlPipe,
        SafePipe,
        DomSanitizerPipe,
        MenuMobileComponent,
        BsDropdownModule,
        PopoverModule
    ],
    declarations: [
        MotorReservaComponent,
        SeccionDescubreenjoyComponent,
        MapsComponent,
        MenuMobileComponent,
        CotizacionComponent,
        Error404Component,
        NumberDirective,
        NumberLettersDirective,
        ModalSuccesEnjoyClComponent,
        CleanUrlPipe,
        FormatTextPipe,
        SafePipe,
        DomSanitizerPipe,
        ModalErrorEnjoyClComponent
    ],
    providers: [
        DatePipe,
        UnidadGuard,
        ServicioGuard,
        DataGuard
        ],
    entryComponents: [
        ModalSuccesEnjoyClComponent,
        ModalErrorEnjoyClComponent
    ]
})
    
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule
        };
    }
}

/* export class AppModule(){} */
